import React from 'react';


const Nutrition = () => {
  return (
    <div className="page-container nutrition-page">
      <h1 className="page-title">Nutrition and Healthy Eating</h1>

      {/* Include the image */}
      <img
        src="/images/wf-nutrition.webp" // Path to image in public folder
        alt="Healthy food and lifestyle"
        className="page-image"
      />

      <p className="page-intro">
        Good nutrition is not just about eating the right foods—it’s about fueling your body with the energy and nutrients it needs to thrive.
      </p>

      <p className="page-text">
        Nutrition plays a crucial role in achieving optimal health. The food we eat directly impacts our physical and mental performance, energy levels, and overall well-being. A balanced diet that includes a variety of essential nutrients is key to maintaining a healthy body and mind.
      </p>
      
      <p className="page-text">
        In this section, we’ll explore topics such as creating a balanced diet, understanding the role of essential nutrients, and developing sustainable eating habits. Whether you're new to healthy eating or looking to optimize your nutrition plan, this guide will provide the tools and resources you need.
      </p>

      <hr className="page-divider" />

      <h2 className="section-title">Health Benefits of Good Nutrition</h2>
      <p className="section-description">
        Proper nutrition offers countless health benefits, including:
      </p>
      <ul className="content-list">
        <li>Boosted energy levels and reduced fatigue</li>
        <li>Improved immune function and resistance to disease</li>
        <li>Better cognitive function and mental clarity</li>
        <li>Enhanced mood and emotional well-being</li>
        <li>Reduced risk of chronic diseases (heart disease, diabetes, etc.)</li>
        <li>Support for healthy weight management</li>
      </ul>




      <hr className="page-divider" />

      <h2 className="section-title">Creating Healthy Nutrition Habits</h2>
      <p className="section-description">
        It’s not enough to simply know what to eat—you need to make it a part of your lifestyle. Developing healthy eating habits requires intentional planning and consistency. Here are some strategies to help you build and maintain healthy eating habits:
      </p>

      <h3 className="content-subtitle">Framework for Building Healthy Eating Habits:</h3>
      <ul className="content-list">
        <li><strong>Start Small:</strong> Begin by making small, manageable changes to your diet. For example, start by adding more fruits and vegetables to your meals, or reducing processed sugar intake.</li>
        <li><strong>Be Consistent:</strong> Consistency is key to forming lasting habits. Aim to stick to your plan even on challenging days, and celebrate small wins along the way.</li>
        <li><strong>Track Your Progress:</strong> Keep a food journal or use an app to track your meals and monitor how your eating habits are improving. Reflect on how your body feels after eating healthier meals.</li>
      </ul>

      <h3 className="content-subtitle">Examples of Healthy Eating Habits:</h3>
      <ul className="content-list">
        <li>Start your day with a balanced breakfast that includes protein, healthy fats, and fiber.</li>
        <li>Eat a variety of colorful fruits and vegetables every day to ensure you’re getting a wide range of nutrients.</li>
        <li>Drink plenty of water throughout the day to stay hydrated and support overall bodily functions.</li>
        <li>Prepare meals at home to control ingredients and portions, ensuring healthier meals overall.</li>
        <li>Practice mindful eating—take the time to chew your food thoroughly and enjoy your meals without distractions.</li>
      </ul>

      <p className="section-description">
        By implementing these simple yet effective habits, you can improve your nutrition and foster lasting health benefits.
      </p>

      <hr className="page-divider" />

      <h2 className="section-title">Popular Apps for Nutrition Tracking</h2>
      <p className="section-description">
        These apps can help you track your meals, manage your calories, and optimize your nutrition:
      </p>

      <h3 className="content-subtitle">MyFitnessPal</h3>
      <p>
        MyFitnessPal is a popular app for tracking calories and macronutrients. It has a large database of foods, making it easy to log your meals and keep track of your nutritional intake.
      </p>

      <h3 className="content-subtitle">Lose It!</h3>
      <p>
        Lose It! helps you track food intake, set goals, and monitor progress. It also allows you to scan barcodes for easy entry of packaged foods.
      </p>

      <h3 className="content-subtitle">Yazio</h3>
      <p>
        Yazio offers personalized meal plans, and helps track macronutrients, vitamins, and calories to support your health goals.
      </p>

      <hr />

      <h2 className="section-title">Join the Nutrition Community Forum</h2>
      <p className="section-description">
        Have any nutrition questions or tips to share? Our community forum is the perfect place to ask questions, exchange ideas, and find support in your health journey.
      </p>
      <div className="mini_void"></div>
      <a href="/forum/Nutrition" className="forum-link">
        Go to Nutrition Forum
      </a>
    </div>
  );
};

export default Nutrition;
